











import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {defineComponent, reactive} from "@vue/composition-api"
import appConf from "@/config"
import {getStoredProcedure} from "@/data/repos/storedProcedure"
import {getLocationCaption} from "@/data/sources/appraisal"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.KeyValue(),
    widget: 'FloorsWithoutDrawings',
    title: 'Floors With No (As Built) Drawings',
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
  }
}

function getChartConfig() {
  return reactive(FCConfTpl())
}

function getChartDataConfig() {
  return reactive({
      ...ChartDataTemplate(),
      caption: 'Floors',
      theme: 'micad',
      legendCaption: 'Legend',
      // legendCaptionFontSize: "9",
    },
  )
}

async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
  if (config) {
    chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
  }
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    FusionChartWidget,
  },
  setup(props, context) {
    context.emit('config-update', config())
    return {dataFetcher, getChartDataConfig, chartClickCallback, configChangeCallback}
  },
})

async function dataFetcher(params: any): Promise<{ data: { value: string, label: string }[] }> {
  return {
    data: await getStoredProcedure(
      'AnalyticsCenter',
      'widget_FloorsWithoutDrawings',
      [parseInt(params.locationId.value) || 10, 1]),
  }
}

function chartClickCallback(label: string, val: any) {
  const url = appConf.IPR_BASE_URL + '/reports/LocIssuesFloorsWithoutPlans.asp'
  window.open(url)
}

